import { render, staticRenderFns } from "./Warriors.vue?vue&type=template&id=24579944&scoped=true"
import script from "./Warriors.vue?vue&type=script&lang=js"
export * from "./Warriors.vue?vue&type=script&lang=js"
import style0 from "./Warriors.vue?vue&type=style&index=0&id=24579944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24579944",
  null
  
)

export default component.exports